import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/tiptap-content.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
import { NotificationProvider } from "./Sections/Notification/NotificationProvider";
import { SocketConnectionProvider } from "./components/SocketConnection";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <SocketConnectionProvider>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </SocketConnectionProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
